import urljoin from 'url-join'
import ServicesUtils from '@/utils/servicesUtils'

function getApiStatus ()
{
    let url = urljoin(ServicesUtils.apiUrl, `status`)
    
    return ServicesUtils.pingHost(url)
}

export default { getApiStatus }


// WEBPACK FOOTER //
// ./src/services/status.js